// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"515":"cityCompany","597":"storeEnter","982":"myAbout","994":"newAsync"}[chunkId] + "." + {"515":"cebe6502","597":"340fd555","982":"51ceb732","994":"d380db5f"}[chunkId] + ".css";
};